import { Children, Dispatch, SetStateAction, useContext, useState } from 'react';

import facebookImage from '../../assets/images/icons/facebook.svg';
import instagramImage from '../../assets/images/icons/instagram.png';
import linkedInImage from '../../assets/images/icons/linkedin.png';
import twitterImage from '../../assets/images/icons/twitter.svg';
import InputAnimatedConfirm from '../../components/atoms/input-animated/InputAnimatedConfirm';
import { AuthContext } from '../../utils/AuthProvider';

interface SocialMediaButtonsProps {
  instagram: string;
  facebook: string;
  linkedIn: string;
  twitter: string;
  setFacebook: Dispatch<SetStateAction<string>>;
  setInstagram: Dispatch<SetStateAction<string>>;
  setLinkedIn: Dispatch<SetStateAction<string>>;
  setTwitter: Dispatch<SetStateAction<string>>;
}

function SocialMediaButtons({
  instagram,
  facebook,
  linkedIn,
  twitter,
  setInstagram,
  setFacebook,
  setLinkedIn,
  setTwitter,
}: SocialMediaButtonsProps) {
  const [isSocialButtonsVisible, setIsSocialButtonsVisible] = useState<boolean>(true);
  const [currentSocialButton, setCurrentSocialButton] = useState<string>('');
  const { userProfile } = useContext(AuthContext)!;

  function setSocialButton(socialMediaIdentifier: string) {
    setIsSocialButtonsVisible(false);
    setCurrentSocialButton(socialMediaIdentifier);
  }

  function discard() {
    setIsSocialButtonsVisible(true);
    if (userProfile) {
      switch (currentSocialButton) {
        case facebookImage:
          setFacebook(userProfile.facebook ? userProfile.facebook : '');
          break;
        case instagramImage:
          setInstagram(userProfile.instagram ? userProfile.instagram : '');
          break;
        case linkedInImage:
          setLinkedIn(userProfile.linkedIn ? userProfile.linkedIn : '');
          break;
        case twitterImage:
          setTwitter(userProfile.twitter ? userProfile.twitter : '');
          break;
        default:
          break;
      }
    }
    setCurrentSocialButton('');
  }

  function confirm() {
    setIsSocialButtonsVisible(true);
  }

  const SOCIAL_LINKS_DATA = [
    {
      image: instagramImage,
      value: instagram,
      valueSetter: setInstagram,
    },
    {
      image: facebookImage,
      value: facebook,
      valueSetter: setFacebook,
    },
    {
      image: linkedInImage,
      value: linkedIn,
      valueSetter: setLinkedIn,
    },
    {
      image: twitterImage,
      value: twitter,
      valueSetter: setTwitter,
    },
  ];

  const socialLinks = Children.toArray(
    SOCIAL_LINKS_DATA.map(socialObject => {
      return (
        <>
          {isSocialButtonsVisible && (
            <button key={socialObject.image} onClick={() => setSocialButton(socialObject.image)}>
              <img className="social-link-image" src={socialObject.image} alt="" />
            </button>
          )}
          {!isSocialButtonsVisible && currentSocialButton === socialObject.image && (
            <InputAnimatedConfirm
              className="input-tile"
              placeholder={'Enter social media profile link'}
              value={socialObject.value}
              setState={socialObject.valueSetter}
              image={socialObject.image}
              confirmFunction={confirm}
              discardFunction={discard}
            />
          )}
        </>
      );
    })
  );

  return <>{socialLinks}</>;
}

export default SocialMediaButtons;
